import classNames from "classnames";
import { ErrorMessage, useField, useFormikContext } from "formik";
import React from "react";
import { FloatingLabel, Form, FormControlProps } from "react-bootstrap";
import PopoverBtn from "../popoverBtn";

interface IInputTextAreaProps extends FormControlProps {
  height?: number;
  rows?: number;
  popoverText?: string;
  isValidateImmediate?: boolean;
}
export default function InputTextArea({
  rows,
  height,
  className,
  popoverText,
  isValidateImmediate = false,
  ...props
}: IInputTextAreaProps) {
  const [field, meta] = useField(props.name);
  const { setFieldTouched } = useFormikContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    isValidateImmediate && setFieldTouched(field.name, true);
  };

  return (
    <FloatingLabel
      label={props.placeholder}
      className={classNames(className, {
        "position-relative": !!popoverText,
      })}
    >
      <Form.Control
        as="textarea"
        {...field}
        {...props}
        onChange={handleChange}
        isInvalid={meta.touched && !!meta.error}
        isValid={meta.touched && !meta.error && !!field.value}
        rows={rows || 4}
        style={{ height: height || 100 }}
      />
      <ErrorMessage
        name={props.name}
        component="div"
        className="text-danger error-field"
      />
      {popoverText && (
        <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
          <PopoverBtn text={popoverText} />
        </div>
      )}
    </FloatingLabel>
  );
}
